import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 20,
			fill: "#7548F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7625 26.5175V13.4825C18.7625 12.245 18.24 11.75 16.92 11.75H13.5925C12.2725 11.75 11.75 12.245 11.75 13.4825V26.5175C11.75 27.755 12.2725 28.25 13.5925 28.25H16.92C18.24 28.25 18.7625 27.755 18.7625 26.5175Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.2508 26.5175V13.4825C28.2508 12.245 27.7283 11.75 26.4083 11.75H23.0808C21.7699 11.75 21.2383 12.245 21.2383 13.4825V26.5175C21.2383 27.755 21.7608 28.25 23.0808 28.25H26.4083C27.7283 28.25 28.2508 27.755 28.2508 26.5175Z",
			fill: "white"
		})
	]
});
export default SvgPause;
